// extracted by css-extract-rspack-plugin
export default {"markdown":"qF6n2"};